<template>
  <div class="content_box">
    <div class="head_box">
      <img src="../../src/assets/icon.png" class="icon_img" />
    </div>
    <div>
      <van-cell-group>
        <van-cell>
          <van-field v-model="phoneNumber" type="tel" label="手机号" placeholder="请输入手机号" />
        </van-cell>
        <van-cell v-if="loginStatus">
          <van-field v-model="code" center clearable label="短信验证码" placeholder="请输入短信验证码">
            <template #button>
              <van-button v-if="show" @click="sendCodeBeforeLogin" size="small" type="primary">发送验证码</van-button>
              <div v-else>{{times}}s</div>
            </template>
          </van-field>
        </van-cell>
        <van-cell v-else>
          <van-field v-model="password" type="password" label="密码" placeholder="请输入密码" />
        </van-cell>
      </van-cell-group>
      <div class="changeStatus" @click="loginStatus=!loginStatus">{{loginStatus?'密码登录':'验证码登录'}}</div>
      <div style="padding:0.5rem">
        <van-button @click="beforeLogin" type="primary" block>登录</van-button>
      </div>
      <!-- <div class="actingCapture" @click="toActingCapture">电费代缴（无需登录）</div> -->
    </div>
  </div>
</template>
<script>
import { sendCodeBeforeLogin, pwdLogin, loginByCode } from "@/api/user.js";
import Vue from "vue";
import { Field } from "vant";
import { Cell, CellGroup, Button } from "vant";
import { Notify } from "vant";
import { setToken, getToken } from "@/libs/util.js";
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Field);
Vue.use(Button);
export default {
  data() {
    return {
      code: "",
      times: 60,
      show: true,
      password: "",
      url: config.url,
      phoneNumber: "",
      loginStatus: true,
      appId: config.appId
    };
  },
  created() {
    console.log(localStorage.getItem("openId"));
  },
  methods: {
    toActingCapture() {
      location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
        this.appId
      }&redirect_uri=${encodeURIComponent(this.url)}${encodeURIComponent(
        "tcmr/actingCapture"
      )}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`;
    },
    getCode() {
      this.show = false;
      this.timer = setInterval(() => {
        this.times--;
        if (this.times === 0) {
          this.times = 60;
          this.show = true;
          clearInterval(this.timer);
        }
      }, 1000);
    },
    isPoneAvailable(pone) {
      var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (!myreg.test(pone)) {
        return false;
      } else {
        return true;
      }
    },
    sendCodeBeforeLogin() {
      if (this.phoneNumber) {
        sendCodeBeforeLogin(this.phoneNumber).then(res => {
          if (res.data.status == 200) {
            this.getCode();
            Notify({ type: "success", message: "验证码发送成功！" });
          } else {
            Notify({ type: "danger", message: res.data.msg });
          }
        });
      } else {
        Notify({ type: "danger", message: "请先输入手机号！" });
      }
    },

    beforeLogin() {
      let loginObj = {};
      if (!this.phoneNumber) {
        Notify({ type: "danger", message: "请先输入手机号！" });
        return;
      }
      if (!this.isPoneAvailable(this.phoneNumber)) {
        Notify({ type: "danger", message: "请输入合法的手机号！" });
        return;
      }
      if (this.loginStatus) {
        if (!this.code) {
          Notify({ type: "danger", message: "请先获取手机验证码！" });
          return;
        }
        loginObj = {
          phoneNumber: this.phoneNumber,
          code: this.code
        };
        loginByCode(loginObj).then(res => {
          if (res.data.status == 200) {
            Notify({
              type: "success",
              message: "登录成功"
            });
            setToken(res.data.object);
            this.$router.push({
              path: `/tcmr/home`
            });
          } else {
            Notify({ type: "danger", message: res.data.msg });
          }
        });
      } else {
        if (!this.password.length > 5) {
          Notify({
            type: "danger",
            message: "请输入密码,且密码长度不能小于六位！"
          });
          return;
        }
        loginObj = {
          username: this.phoneNumber,
          password: this.password
        };
        pwdLogin(loginObj).then(res => {
          if (res.data.status == 200) {
            Notify({
              type: "success",
              message: "登录成功"
            });
            setToken(res.data.object);
            this.$router.push({
              path: `/tcmr/home`
            });
          } else {
            Notify({ type: "danger", message: res.data.msg });
          }
        });
      }
    }
  }
};
</script>
<style  scoped>
.actingCapture {
  color: #008c65;
  font-size: 0.24rem;
  margin-top: 0.3rem;
}
.changeStatus {
  font-size: 0.24rem;
  float: right;
  padding: 0.3rem 0.5rem;
}
.van-button--small {
  height: 28px;
}
.van-button--primary {
  border-color: #008c65;
  background-color: #00a578;
}
.van-cell {
  padding: 5px 16px;
}
.van-button--block {
  height: 0.65rem;
  border-color: #008c65;
  background-color: #00a578;
}
.code_login {
  font-size: 12px;
  margin-top: 20px;
  color: #458c85;
  text-align: right;
  padding-right: 30px;
}
.code_login2 {
  font-size: 12px;
  margin-top: 20px;
  color: #b1b1b1;
  text-align: center;
}
.icon_img {
  width: 3.2rem;
  height: 3.2rem;
}
.forget_pwd {
  float: right;
  font-size: 12px;
  margin-top: 10px;
  color: #458c85;
  padding-right: 30px;
}
</style>
